import Gallery3D from "../../../components/Gallery3D"
import TitleIcon from "./title.svg"

const Start = 0.6
const Tiles = [
  {
    path: "/assets/textures/gallery/coronation_square/img-1a.jpg",
    position: {
      x: 0 + Start,
      y: 0.4
    },
    title: {
      label: "",
      position: { x: 0, y: 0 }
    },
    caption: {
      label: "AUCKLAND ROAD",
      position: { x: 0, y: 0 }
    }
  },
  {
    path: "/assets/textures/gallery/coronation_square/img-1b.jpg",
    position: {
      x: 2.2 + Start,
      y: 0.1
    },
    title: {
      label: "",
      position: { x: 0, y: 0 }
    },
    caption: {
      label: "CORONATION SQUARE",
      position: { x: 0, y: 0 }
    }
  },
  {
    path: "/assets/textures/gallery/coronation_square/img-1c.jpg",
    position: {
      x: 5 + Start,
      y: -0.2
    },
    title: {
      label:
        "2,900 sq ft public square brings Coronation Square to life with central water feature, landscaped greenery and open space perfect for enjoying the shops, cafes and bustling market days.",
      position: { x: 0, y: 1.16 }
    },
    caption: {
      label: "CORONATION SQUARE",
      position: { x: 0, y: 0 }
    }
  },
  {
    path: "/assets/textures/gallery/coronation_square/img-1d.jpg",
    position: {
      x: 7.5 + Start,
      y: 0.15
    },
    title: {
      label:
        "Private residents podium garden with landscaped lawn, productive garden and play space",
      position: { x: 0, y: -0.06 }
    },
    caption: {
      label: "RESIDENTS PODIUM GARDEN AND PLAY AREA",
      position: { x: 0, y: 0 }
    }
  },
  {
    path: "/assets/textures/gallery/coronation_square/img-1e.jpg",
    position: {
      x: 10 + Start,
      y: 0.15
    },
    title: {
      label:
        "Public courtyard garden for a place to come together with friends, family and neighbours",
      position: { x: 0.4, y: -0.02 }
    },
    caption: {
      label: "PUBLIC GARDEN AND PLAY AREA",
      position: { x: 0, y: 0 }
    }
  }
]
const Title = {
  icon: TitleIcon,
  top: "auto",
  left: "4vw",
  bottom: "0vw",
  right: "auto",
  width: "39vw"
}
const CoronationSquareGallery = () => (
  <Gallery3D title={Title} tiles={Tiles} speed={0} length={12.6} />
)

export default CoronationSquareGallery
